import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { AddTimeOffCommand } from './add-time-off.command';

@Injectable({ providedIn: 'root' })
export class AddTimeOffUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: AddTimeOffCommand): Observable<string> {
    return this._repository.addTimeOff(command.userId, {
      timeOffTypeId: command.timeOffTypeId,
      startDate: command.startDate,
      endDate: command.endDate,
      notes: command.notes,
      delegations: command.delegations.map((d) => ({ teamId: d.teamId, delegateUserId: d.delegateUserId })),
    });
  }
}
